const i18nStrings = {
    appName: 'Workshop Studio',
    close: 'Close',
    closeWindow: 'Close window',
    emptyValue: '-',
    errors: {
        notFound: {
            title: 'Page not found',
            message:
                'The page you are looking for does not exist. You might have typed the address incorrectly or you might have used an outdated link. Please check the link and try again.',
        },
    },
    signIn: {
        title: 'Sign in',
        description: 'Choose a preferred sign-in method',
        signingIn: 'Signing in...',
        providers: {
            email: {
                label: 'Email one-time password (OTP)',
                description:
                    'Enter your personal or corporate email to receive a one-time password',
            },
            amazonRetail: {
                label: 'Login with Amazon',
                description: 'Login with your Amazon.com retail account',
            },
            amazonInternal: {
                label: 'Amazon employee',
                description:
                    'Login with your Amazon Corporate account. Only for Amazon Employees.',
            },
        },
        callback: {
            signingIn: 'Completing sign-in...',
            signInFailure:
                'Failed to sign in at this time. Please try clearing cookies and refreshing the page. If the problem persists, please try refreshing the page at a later time.',
        },
    },
    event: {
        headers: {
            dashboard: 'Event dashboard',
            eventInformation: 'Event information',
            workshop: 'Workshop',
            sshKey: {
                title: 'EC2 SSH key',
                name: 'Key name',
                fingerprint: 'Fingerprint',
                privateKey: 'Private key',
            },
        },
        downloadKeyPair: 'Download key pair',
        openAWSConsole: 'Open AWS console',
        getAWSCliCredentials: 'Get AWS CLI credentials',
        getEC2SshKey: 'Get EC2 SSH key',
        aboutEnvironmentVariables: {
            p1:
                'These environment variables need to be set in your terminal session to run AWS CLI commands against your temporary AWS account. Learn more about the AWS CLI in the',
            cta: 'official user guide',
        },
        startWorkshop: 'Get started',
        exit: 'Exit event',
        loadingDashboard: 'Loading event dashboard...',
        loadingContent: 'Loading event content...',
        labels: {
            startTime: 'Start time',
            duration: 'Duration',
            description: 'Description',
            accessibleRegions: 'Accessible regions',
            title: 'Title',
            complexityLevel: 'Complexity level',
            AWSServices: 'AWS services',
            topics: 'Topics',
        },
        sections: {
            AWSAccountAccess: 'AWS account access',
        },
        errors: {},
        modals: {
            eventEnded: {
                header: 'Event ended',
                content: 'The event is now over. Thank you for attending!',
                actionPrimary: 'Exit event',
            },
        },
        notifications: {
            eventNotStarted: {
                header: 'Event not started',
                content: 'Please wait until your facilitator starts the event.',
            },
            eventInProgress: {
                content: 'Event ends in {0}.',
            },
            eventEnded: {
                content: 'Event ended.',
            },
            eventPaused: {
                header: 'Event paused',
                content:
                    'Please wait until your facilitator resumes the event.',
            },
            noCurrentParticipant: {
                content:
                    'You are currently not participating in any active event.',
            },
        },
    },
};

export default i18nStrings;
